import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpCharsetInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let requestToHandle = request;

    if (request.method === 'POST' || request.method === 'PUT') {
      const contentType = request.headers.get('Content-Type');

      if (contentType === null || contentType === 'application/json') {
        requestToHandle = request.clone({
          setHeaders: {
            'Content-Type': 'application/json; charset=utf-8',
          },
        });
      }
    }

    return next.handle(requestToHandle);
  }
}
